/* unplugin-vue-components disabled */import script from "./disease.vue?vue&type=script&setup=true&lang=ts"
export * from "./disease.vue?vue&type=script&setup=true&lang=ts"

import "./disease.vue?vue&type=style&index=0&id=2b5eaf1c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b5eaf1c"]])

export default __exports__